import { Trans } from '@lingui/react'

import { useSubmitNewBankAccountMutation } from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { Typography } from '@twisto/components/atoms/typography'
import {
  NumberedList,
  NumberedListItem,
} from '@twisto/components/molecules/list'
import { BigBankAddIcon } from '@twisto/icons'
import { joinPaths } from '@twisto/utils'

import { BankAccountsLayout } from '../../components'
import { useFlow } from '../../flow/flow.context'

import * as styles from './add-new-bank-account-step.styles'

export const AddNewBankAccountStep = () => {
  const { sessionId } = useFlow()
  const [submitAddNewBankAccount, { loading }] =
    useSubmitNewBankAccountMutation()

  const handleAddBank = () => {
    const redirectUrl = joinPaths(
      window.location.origin,
      '/app/cash/',
      sessionId
    )

    submitAddNewBankAccount({
      variables: {
        auth: {
          sessionId,
        },
        input: {
          redirectUrl,
        },
      },
    })
  }

  const translationKeys = [
    <Trans key="1" id="flow.addNewBankAccountStep.list.1" />,
    <Trans key="2" id="flow.addNewBankAccountStep.list.2" />,
    <Trans key="3" id="flow.addNewBankAccountStep.list.3" />,
  ]

  return (
    <BankAccountsLayout
      end={
        <>
          <Typography css={styles.title} fontWeight="medium" variant="b1">
            <Trans id="flow.addNewBankAccountStep.list.title" />
          </Typography>

          <NumberedList css={styles.numberList}>
            {translationKeys.map((translation, index) => (
              <NumberedListItem key={index}>{translation}</NumberedListItem>
            ))}
          </NumberedList>

          <TextButton
            fullWidth
            css={styles.button}
            disabled={loading}
            onClick={() => handleAddBank()}
          >
            <Trans id="flow.addNewBankAccountStep.button.getStarted" />
          </TextButton>
        </>
      }
      start={
        <Headline>
          <HeadlineIcon>
            <BigBankAddIcon color="primary" height="100%" width="100%" />
          </HeadlineIcon>
          <HeadlineTitle>
            <Trans id="flow.addNewBankAccountStep.title" />
          </HeadlineTitle>
          <HeadlineSubtitle>
            <Trans id="flow.addNewBankAccountStep.subtitle" />
          </HeadlineSubtitle>
        </Headline>
      }
    />
  )
}
